import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { postClient, isBasicConfigured } from "../api/protected";
import { getAccountUrl, setAccountUrl } from "../session";
import { toast } from "react-toastify";
import { InlineLoader } from "../components/Loader";

const IS_DEV = process.env.REACT_APP_DEV === "true";

export default function RegisterPage() {
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [accountUrl, setAcc] = useState(getAccountUrl());
  const [phone, setPhone] = useState("");
  const [balance, setBalance] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const a = String(accountUrl).trim();
    const n = String(name).trim();
    if (!a || !n) {
      toast.error("Укажите account_url и name");
      return;
    }
    if (!isBasicConfigured() && !IS_DEV) {
      toast.error("В окружении нет REACT_APP_API_APP_ID / REACT_APP_API_APP_SECRET");
      return;
    }
    setLoading(true);
    const body = {
      account_url: a,
      name: n,
      ...(phone.trim() ? { phone: phone.trim() } : {}),
    };
    const b = balance === "" ? undefined : Number(balance);
    if (b != null && !Number.isNaN(b) && b >= 0) {
      body.balance = b;
    }
    try {
      if (IS_DEV) {
        setAccountUrl(a);
        toast.success("DEV: клиент зарегистрирован");
        nav("/settings");
        return;
      }
      await postClient(a, body);
      setAccountUrl(a);
      toast.success("Клиент зарегистрирован");
      nav("/settings");
    } catch (err) {
      if (/** @type {any} */(err).response?.status === 409) {
        toast.info("Такой account_url уже зарегистрирован");
        setAccountUrl(a);
        nav("/settings");
        return;
      }
      const msg = /** @type {any} */(err).response?.data?.message;
      toast.error(
        String(msg) || err?.message || "Ошибка регистрации",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bodyContainer">
      <div className="authPage">
        <h1 className="authPage__title">Регистрация клиента</h1>
        <p className="text-muted small mb-4">
          <code>POST /clients</code> с <code>account_url</code> в query и в
          теле. Basic Auth из окружения.
        </p>
        <form onSubmit={submit} className="authPage__form">
          <div className="mb-3">
            <label className="form-label" htmlFor="au">
              account_url
            </label>
            <input
              id="au"
              className="form-control"
              value={accountUrl}
              onChange={(e) => setAcc(e.target.value)}
              placeholder="https://your-subdomain.joinposter.com"
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="na">
              Название
            </label>
            <input
              id="na"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="ph">
              Телефон (опционально)
            </label>
            <input
              id="ph"
              className="form-control"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="bl">
              Баланс (опция, {"≥"} 0)
            </label>
            <input
              id="bl"
              type="number"
              className="form-control"
              min="0"
              step="0.01"
              value={balance}
              onChange={(e) => setBalance(e.target.value)}
            />
          </div>
          <div className="d-flex flex-wrap gap-2 align-items-center">
            <button
              type="submit"
              className="link-button link-button--sm d-inline-flex align-items-center justify-content-center"
              style={{ minWidth: "12rem" }}
              disabled={loading}
            >
              {loading ? <InlineLoader label="Отправка" /> : "Зарегистрировать"}
            </button>
            <Link
              to="/settings"
              className="link-button link-button--sm link-button--secondary"
            >
              Назад
            </Link>
          </div>
        </form>
      </div>
    </section>
  );
}
